import current from './current';
import history from './history';
import query from './query';

export default { current, history, query };
